var map = {
	"./jt0.jpg": "HeKN",
	"./jt1.jpg": "xISN",
	"./jt2.jpg": "Goh5",
	"./jt3.jpg": "rKhl",
	"./jt4.jpg": "1kIS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XMYh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto ^\.\/jt.*\.jpg$
// module id = XMYh
// module chunks = 1